<template>
<div class="managebookings" v-if="profile.admin">
    <h1 class="subheading grey--text">Administrerer reservationer</h1>
    <v-container class="mt-1">
        <v-layout row wrap justify-center justify-space-around>
            <v-flex xs12 mt-4>
                <div class="grey--text">Reservationer</div>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout column>
            <Bookings v-bind:adminOn="true" />

        </v-layout>
    </v-container>
</div>
</template>

<script>
import format from 'date-fns/format'
import Bookings from '@/components/Bookings';
export default {
    components: {
        Bookings
    },
    data() {
        return {

        }
    },
    computed: {
        profile() {
            return this.$store.getters.profile
        },
        resources() {
            return this.$store.getters.resources
        },
        horses() {
            return this.$store.getters.horses
        },
        bookings() {
            return this.$store.getters.bookings
        },
        users() {
            return this.$store.getters.users
        },
        userid() {
            return this.$store.state.authUser.uid
        },
        noBookings() {
            return this.bookings.length
        }
    },
    created: function () {
        this.currentDate = format(Date.now(), 'YYYY-MM-DD')
    },
    methods: {
        resourceName(resources, resid) {
            let resource = []
            resource = this.resourceById(resources, resid)
            if (typeof resource !== 'undefined') {
                return resource.name
            } else {
                return ''
            }
        },
        resourceById(resources, residToFind) {
            const resource = resources.find(function (resource) {
                return resource.id === residToFind;
            })
            return resource
        },
        horseName(horses, horseid) {
            let horse = []
            horse = this.horseById(horses, horseid)
            if (typeof horse !== 'undefined') {
                return horse.name
            } else {
                return 'Ukendt'
            }
        },
        horseById(horses, horseidToFind) {
            const horse = horses.find(function (horse) {
                return horse.id === horseidToFind;
            })
            return horse
        },
        userName(users, userid) {
            let user = []
            user = this.userById(users, userid)
            if (typeof user !== 'undefined') {
                return user.name
            } else {
                return ''
            }
        },
        userById(users, useridToFind) {
            const user = users.find(function (user) {
                return user.id === useridToFind;
            })
            return user
        },
        deleteBooking(bookingid) {
            //console.log('delete:' + bookingid)
            this.$store.state.db.collection('bookings').doc(bookingid).delete().then(() => {

                    const index = this.bookings.findIndex(function (booking) {
                        return booking.id === bookingid
                    })
                    if (index > -1) {
                        //console.log('index:' , index)
                        this.bookings.splice(index, 1)
                    }
                })
                .catch(err => {
                    console.log(err.message)
                });
        },
        sortBy(prop) {
            this.bookings.sort((a, b) => a[prop] < b[prop] ? -1 : 1)
        }
    },
    mounted() {

    }
}
</script>

<style scoped>

</style>
